<template>
    <div class="login">
        <el-row style="width: 100%; height: 80px; background: #12c287">
            <el-col :span="5" style="margin-top: 16px">
                <img src="static/img/logo.png" alt="" />
            </el-col>
        </el-row>
        <el-row style="margin-top: 85px; margin-left: 360px">
            <el-col :span="5">
                <div style="position: relation">
                    <img
                        src="/static/images/注册-左侧边装饰图-另一种切法.png"
                        alt=""
                    />
                    <div style="position: absolute; top: 0px; top: 50px">
                        <img src="/static/images/注册.png" alt="" />
                    </div>
                </div>
            </el-col>
            <el-col :span="5" style="margin-left: 275px">
                <div
                    class="welcome3"
                    style="width: 600px; height: 720px; background: #fff"
                >
                    <el-form
                        :class="[
                            msgIsShow
                                ? 'register-form-right'
                                : 'register-form-center',
                        ]"
                        :model="ruleForm2"
                        :rules="rules2"
                        ref="ruleForm2"
                    >
                        <div style="margin-top: 55px; margin-bottom: 10px">
                            <p
                                style="
                                    text-align: left;
                                    color: #12c287;
                                    margin: 0;
                                    font-size: 24px;
                                "
                            >
                                欢迎注册
                            </p>
                            <div
                                style="
                                    width: 96px;
                                    height: 2px;
                                    background: #12c287;
                                    margin-top: 8px;
                                "
                            ></div>
                        </div>
                        <div style="margin-top: 20px; margin-bottom: 30px">
                            <el-form-item prop="tel">
                                <el-input
                                    class="login-input"
                                    v-model="ruleForm2.tel"
                                    auto-complete="off"
                                    placeholder="请输入邮箱号（必填）"
                                ></el-input>
                            </el-form-item>

                            <el-form-item prop="smscode" class="code">
                                <el-input
                                    class="login-input"
                                    v-model="ruleForm2.smscode"
                                    placeholder="验证码"
                                ></el-input>
                                <el-button
                                    type="primary"
                                    :disabled="isDisabled"
                                    @click="sendCode"
                                    >{{ buttonText }}</el-button
                                >
                            </el-form-item>
                            <el-form-item prop="username">
                                <el-input
                                    class="login-input"
                                    v-model="ruleForm2.username"
                                    auto-complete="off"
                                    placeholder="请输入真实姓名（必填）"
                                ></el-input>
                            </el-form-item>
                            <el-form-item prop="work">
                                <el-input
                                    class="login-input"
                                    v-model="ruleForm2.work"
                                    auto-complete="off"
                                    placeholder="请输入工作单位（必填）"
                                ></el-input>
                            </el-form-item>
                            <el-form-item prop="job">
                                <el-input
                                    class="login-input"
                                    v-model="ruleForm2.job"
                                    auto-complete="off"
                                    placeholder="请输入身份职位（选填）"
                                ></el-input>
                            </el-form-item>
                            <el-form-item prop="phone">
                                <el-input
                                    class="login-input"
                                    v-model="ruleForm2.phone"
                                    auto-complete="off"
                                    placeholder="请输入手机号（选填）"
                                ></el-input>
                            </el-form-item>
                            <el-form-item prop="pass">
                                <el-input
                                    type="password"
                                    class="login-input"
                                    v-model="ruleForm2.pass"
                                    auto-complete="off"
                                    placeholder="输入密码"
                                ></el-input>
                            </el-form-item>
                            <el-form-item prop="checkPass">
                                <el-input
                                    type="password"
                                    class="login-input"
                                    v-model="ruleForm2.checkPass"
                                    auto-complete="off"
                                    placeholder="确认密码"
                                ></el-input>
                            </el-form-item>
                        </div>

                        <div style="margin-top: 10px">
                            <el-button
                                class="loginButton"
                                type="primary"
                                @click="submitForm('ruleForm2')"
                                >注册</el-button
                            >
                        </div>

                        <div style="margin-top: 5px">
                            <el-row>
                                <el-col style="text-align: left">
                                    <span
                                        style="font-size: 16px; color: #12c287"
                                        >已有账号？</span
                                    >
                                    <el-button
                                        class="loginNagtiveButton"
                                        type="text"
                                        @click="gotoLogin"
                                        >去登录</el-button
                                    >
                                </el-col>
                            </el-row>
                        </div>
                    </el-form>
                </div>
            </el-col>
        </el-row>
    </div>
</template>

<script>
import axios from 'axios'

export default {
    name: 'Register',
    data() {
        let checkUsername = (rule, value, callback) => {
            if (value === '') {
                callback(new Error('请输入用户名'))
            } else {
                callback()
            }
        }
        // <!--验证邮箱号是否合法-->
        let checkTel = (rule, value, callback) => {
            if (value === '') {
                callback(new Error('请输入邮箱号'))
            } else if (!this.checkMobile(value)) {
                callback(new Error('邮箱号不合法'))
            } else {
                callback()
            }
        }
        //  <!--验证码是否为空-->
        let checkSmscode = (rule, value, callback) => {
            if (value === '') {
                callback(new Error('请输入验证码'))
            } else {
                callback()
            }
        }
        // <!--验证密码-->
        let validatePass = (rule, value, callback) => {
            if (value === '') {
                callback(new Error('请输入密码'))
            } else {
                if (this.ruleForm2.checkPass !== '') {
                    this.$refs.ruleForm2.validateField('checkPass')
                }
                callback()
            }
        }
        // <!--二次验证密码-->
        let validatePass2 = (rule, value, callback) => {
            if (value === '') {
                callback(new Error('请再次输入密码'))
            } else if (value !== this.ruleForm2.pass) {
                callback(new Error('两次输入密码不一致!'))
            } else {
                callback()
            }
        }
        return {
            ruleForm2: {
                username: '',
                pass: '',
                checkPass: '',
                tel: '',
                smscode: '',
                work: '',
                job: '',
                phone: '',
            },
            rules2: {
                username: [{ validator: checkUsername, trigger: 'change' }],
                pass: [{ validator: validatePass, trigger: 'change' }],
                checkPass: [{ validator: validatePass2, trigger: 'change' }],
                tel: [{ validator: checkTel, trigger: 'change' }],
                smscode: [{ validator: checkSmscode, trigger: 'change' }],
            },
            buttonText: '获取验证码',
            isDisabled: false, // 是否禁止点击发送验证码按钮
            flag: true,

            //文字是否展示
            msgIsShow: true,
            screenWidth: document.body.clientWidth,
        }
    },
    mounted() {
        const that = this
        window.onresize = () => {
            return (() => {
                window.screenWidth = document.body.clientWidth
                window.screenHeight = document.body.clientHeight
                that.screenWidth = window.screenWidth
            })()
        }
    },
    watch: {
        screenWidth(val) {
            if (!this.timer) {
                // 为了避免频繁触发resize函数导致页面卡顿，使用定时器
                this.screenWidth = val // 一旦监听到的screenWidth值改变，就将其重新赋给data里的screenWidth
                if (this.screenWidth < 1140) {
                    this.msgIsShow = false
                } else {
                    this.msgIsShow = true
                }
                this.timer = true
                let that = this
                setTimeout(function () {
                    that.timer = false
                }, 400)
            }
        },
    },
    methods: {
        // <!--发送验证码-->
        sendCode() {
            let tel = this.ruleForm2.tel
            if (this.checkMobile(tel)) {
                axios({
                    url: $webConfig.V3.backendAPI + 'mail',
                    method: 'post',
                    data: JSON.stringify({ mail: tel }),
                })
                    .then((res) => {
                        console.log(res)
                    })
                    .catch((err) => {
                        console.log(err)
                    })
                let time = 60
                this.buttonText = '已发送'
                this.isDisabled = true
                if (this.flag) {
                    this.flag = false
                    let timer = setInterval(() => {
                        time--
                        this.buttonText = time + ' 秒'
                        if (time === 0) {
                            clearInterval(timer)
                            this.buttonText = '重新获取'
                            this.isDisabled = false
                            this.flag = true
                        }
                    }, 1000)
                }
            }
        },
        // <!--提交注册-->
        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    console.log(this.ruleForm2)
                    debugger
                    //停止
                    axios({
                        url: $webConfig.V3.backendAPI + 'register',
                        method: 'post',
                        data: JSON.stringify({
                            mail: this.ruleForm2.tel,
                            smscode: this.ruleForm2.smscode,
                            tName: this.ruleForm2.username,
                            work: this.ruleForm2.work,
                            job: this.ruleForm2.job,
                            phone: this.ruleForm2.phone,
                            password: this.ruleForm2.checkPass,
                            other: '',
                        }),
                    })
                        .then((res) => {
                            debugger
                            if (res.status == 200) {
                                if (
                                    res.status == 200 &&
                                    res.data['message'] == '已经保存到数据库中'
                                ) {
                                    this.$message({
                                        message: res.data['message'],
                                        type: 'success',
                                    })
                                    this.$router.push('/login')
                                } else {
                                    this.$message({
                                        message: res.data['message'],
                                        type: 'warning',
                                    })
                                }
                            }
                        })
                        .catch((err) => {
                            console.log(err)
                        })
                } else {
                    console.log('error submit!!')
                    return false
                }
            })
        },
        gotoLogin() {
            this.$router.push({
                path: '/login',
            })
        },
        checkMobile(str) {
            let re = /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+(.[a-zA-Z0-9_-])+/
            if (re.test(str)) {
                return true
            } else {
                return false
            }
        },
    },
}
</script>
<style scoped>
.register-form-right >>> .el-form-item__error {
    font-size: 12px;
    margin: 2px 0px 1px 0px;
}
.register-form-right >>> .el-form-item--small.el-form-item {
    margin-bottom: 22px;
}
.register-form-center >>> .el-form-item__error {
    font-size: 22px;
    margin: 2px 0px 1px 0px;
}
.register-form-center >>> .el-form-item__label:before {
    display: none;
}
.register-form-right >>> .el-form-item__label:before {
    display: none;
}

.login-input >>> .el-input__inner {
    height: 40px;
    font-size: 20px;
    background: #fff;
    border: 1px solid #d9d9d9;
    border-radius: 2px;
    color: black;
}
.login-input >>> .el-input__inner:hover {
    border: 1px solid #12c287;
}
.login-input >>> .el-input__inner:focus {
    border: 1px solid #12c287;
}
.login-input >>> .el-input__inner::placeholder {
    font-size: 16px;
    font-family: PingFangSC-Regular;
    color: rgba(0, 0, 0, 0.25);
}

.code >>> .el-form-item__content {
    display: flex;
    align-items: center;
    justify-content: space-between;
}
@media screen and (max-height: 790px) {
    .welcome {
        background: url(/static/img/地理调查表背景.png) no-repeat center;
        background-size: 100% 100%;
        width: 1130px;
        height: 485px;
        position: relative;
        top: 20%;
        left: 13rem;
    }
}
@media screen and (min-height: 790px) {
    .welcome {
        background: url(/static/img/地理调查表背景.png) no-repeat center;
        background-size: 100% 100%;
        width: 73%;
        height: 70%;
        position: relative;
        top: 15%;
        left: 13%;
    }
}
#register {
    max-width: 340px;
    margin: 60px auto;
    background: #fff;
    padding: 20px 40px;
    border-radius: 10px;
    position: relative;
    z-index: 9;
}
.loginNagtiveButton {
    color: #12c287 !important;
    font-size: 16px !important;
}
.loginNagtiveButton:hover {
    font-weight: 400 !important;
    color: #12c287 !important;
    line-height: 22px !important;
}
.loginButton {
    background: #12c287 !important;
    width: 380px !important;
    height: 40px !important;
    padding: 0px 20px !important;
    line-height: 24px !important;
    font-size: 16px !important;
    border-radius: 2px !important;
}
</style>



// WEBPACK FOOTER //
// src/V3/Register.vue